import {
  PASSWORD_CHANGE_REQUEST,
  PASSWORD_CHANGE_SUCCESS,
  PASSWORD_CHANGE_ERROR,
} from "./actions";

const initialState = {
  requesting: false,
  successful: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PASSWORD_CHANGE_REQUEST:
      return {
        requesting: true,
        successful: false,
      };

    case PASSWORD_CHANGE_SUCCESS:
      return {
        requesting: false,
        successful: true,
      };

    case PASSWORD_CHANGE_ERROR:
      return {
        requesting: false,
        successful: false,
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/pages/password-change/reducer.js